import { getDateRangeForFilterPeriod } from '@workalizer/shared/utils/analyticsFilterPeriod';
export function getDateRangeForPeriod(period, refDate) {
    if (refDate === void 0) { refDate = new Date(); }
    return getDateRangeForFilterPeriod(period, refDate);
}
